import {ReactNode, useEffect} from 'react'
import { useMsal } from '@azure/msal-react'
import axios from 'axios'
import { signinRequest } from '../authentication/authConfig'
import { InteractionRequiredAuthError } from '@azure/msal-browser'

const RequestInterceptor = ({children}: { children?: ReactNode }) => {
    const { instance } = useMsal()

    useEffect(() => {
        const interceptor = axios.interceptors.request.use(async (config) => {
            const response = await instance
                .acquireTokenSilent(signinRequest)
                .catch((error) => {
                    if (error instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect(signinRequest)
                      }
                    console.error(
                        'Not able to get the access token for this active account'
                    )
                })

            if (!response?.accessToken) {
                console.error('No access token available')
                instance.acquireTokenRedirect(signinRequest)
            }

            const bearer = `Bearer ${response?.accessToken}`
            if (config.headers) {
                config.headers.Authorization = bearer
                config.headers['Ocp-Apim-Subscription-Key'] = process.env.REACT_APP_subscription_key ?? ''
                config.headers['Content-Type'] = 'application/json'
            }
            return config
        })
        return () => {
            axios.interceptors.request.eject(interceptor)
        }
    }, [])

    return <>{children}</>
}
export { RequestInterceptor }
